<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Resources
            </v-row>
            <div v-if="resources?.length > 0">
                <!--resources table head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col v-for="(item, i) in headers" :key="i" 
                        class="tabCell"
                        :class="item.style">
                        {{ item.title }}
                    </v-col>
                </v-row>
                <!-- resources tab -->
                <v-row v-for="resource in resources" :key="resource.id" no-gutters>
                    <v-col class="tabCell text-left">{{ resource.team?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(resource.capacities) }}</v-col>
                    <v-col class="tabCell text-center">{{ resource.capacities_increase }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(resource.long_term_debt) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(resource.borrowings) }}</v-col>    
                    <v-col class="tabCell text-center">{{ selializing(resource.research_segments) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(resource.research_costs) }}</v-col>
                    <v-col class="tabCell text-right">
                        <delete-resource :resource="resource" />
                    </v-col>    
                </v-row>
            </div>
            <v-row v-else class="mt-8 px-4" justify="center">
                You haven't resources yet!
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import { localeNumber } from '../../../functions/common';
import Loader from '../../../layouts/Loader.vue';
import deleteResource from '../../../components/admin/resources/deleteResource.vue';

export default {
    data() {
        return {
            headers: [
                { title: 'Team', style: 'text-left' },
                { title: 'Capacities current round', style: 'text-center' },
                { title: 'Capacities increase for next round', style: 'text-center' },
                { title: 'Current long-term debt', style: 'text-center' },
                { title: 'Borrowings current round', style: 'text-center' },
                { title: 'Segments for research', style: 'text-center' },
                { title: 'Research costs', style: 'text-center' },
                { title: 'Action', style: 'text-right' },
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        resources() {
            return this.$store.getters.resources;
        },
    },
    methods: {
        formatNumber(num) {
            return localeNumber(num, this.locale)
        },
        getValue(val) {
            return this.values.find(v => v.value === val).text;
        },
        selializing(arr) {
            if (arr && arr.length) {
                return arr.join(', ');
            }
            return ''    
        }
    },
    components: { Loader, deleteResource},
}
</script>